export default __webpack_public_path__ + "static/media/home-projection-vector.3f9de5a8.svg";